export default "__VITE_ASSET__COC28ZmP__"